/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRotateClockwise = createReactComponent("rotate-clockwise", "IconRotateClockwise", [
  ["path", { d: "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5", key: "svg-0" }]
]);

export { IconRotateClockwise as default };
//# sourceMappingURL=IconRotateClockwise.js.map
